import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminApiService } from '../../services/admin-api.service';

@Component({
  selector: 'app-user-performance-dashboard',
  templateUrl: './user-performance-dashboard.component.html',
  styleUrl: './user-performance-dashboard.component.css',
  standalone: false
})
export class UserPerformanceDashboardComponent implements OnInit {

  @Input() userId!: string;
  @Input() sessionId!: string;
  @Input() userData: any;

  userPerformanceData: any;
  loadingDashboard = false;

  constructor(
    private route: ActivatedRoute,
    private adminApi: AdminApiService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.userId = params.get('userId') || this.userId || '';
      this.sessionId = params.get('sessionId') || this.sessionId || '';

      if (!this.userId || !this.sessionId) {
        this.userPerformanceData = this.getMockData();
        return;
      }

      this.loadDashboard();
    });
  }

  loadDashboard(): void {
    this.loadingDashboard = true;
    this.adminApi.getUserDashboard(this.userId, this.sessionId).subscribe({
      next: (res) => {
        this.userPerformanceData = res?.userDashboard || this.getMockData();
        this.loadingDashboard = false;
      },
      error: (err) => {
        console.error('Failed to load dashboard', err);
        this.userPerformanceData = this.getMockData();
        this.loadingDashboard = false;
        this.snackBar.open('Failed to load dashboard. Showing mock data.', 'Dismiss', { duration: 3000 });
      }
    });
  }

  getMockData(): any {
    return {
      "userId": "TEST-USER-1-v1",
      "sessionId": "92152333",
      "assessment_id": "92152333",
      "near_qualifying_roles": [
      ],
      "normalized_scores": {
       "3d-visual": 2,
       "aesthetic": 2,
       "attention-to-detail": -0.25,
       "comprehension-skills": -1.5,
       "critical-thinking": 1.25,
       "data-analytics-skills": 1.75,
       "depth-perception": -0.25,
       "logical-reasoning": -0.25,
       "numerical-reasoning-skills": 1.75,
       "persuasive-communication-skills": -0.25,
       "probability-estimations": -0.25,
       "problem-solving": 1.25,
       "quantitative-fluency": 0.75
      },
      "percentile_info": {
       "note": "Need more user data for accurate percentile calculation",
       "overall_percentile": 50,
       "percentile_category": "Insufficient Data",
       "strengths": [
       ],
       "trait_percentiles": {
        "3d-visual": 50,
        "aesthetic": 50,
        "attention-to-detail": 50,
        "comprehension-skills": 50,
        "critical-thinking": 50,
        "data-analytics-skills": 50,
        "depth-perception": 50,
        "logical-reasoning": 50,
        "numerical-reasoning-skills": 50,
        "persuasive-communication-skills": 50,
        "probability-estimations": 50,
        "problem-solving": 50,
        "quantitative-fluency": 50
       },
       "weaknesses": [
       ]
      },
      "profile_type": {
       "balance_score": 0.6500484498010279,
       "mean_score": 62.30769230769231,
       "peak_skills": [
       ],
       "profile_type": "Balanced",
       "recommendation": "Good balance between specialization and versatility",
       "skill_range": 70,
       "specialization_index": 0.349951550198972,
       "std_score": 21.804673512397486,
       "weak_skills": [
        "comprehension-skills"
       ]
      },
      "qualified_roles": {
       "by_industry": {
        "consulting": [
         {
          "average_exceed": 5,
          "industry": "consulting",
          "match_percentage": 100,
          "match_score": 100.5,
          "qualification_status": "qualified",
          "requirements_details": [
           {
            "exceed_by": 0,
            "required": 85,
            "status": "met",
            "trait": "numerical-reasoning-skills",
            "user_value": 85
           },
           {
            "exceed_by": 10,
            "required": 75,
            "status": "met",
            "trait": "data-analytics-skills",
            "user_value": 85
           }
          ],
          "requirements_met": 2,
          "role_id": "consulting_finance-audit",
          "role_type": "finance-audit",
          "total_requirements": 2
         },
         {
          "average_exceed": 0,
          "industry": "consulting",
          "match_percentage": 100,
          "match_score": 100,
          "qualification_status": "qualified",
          "requirements_details": [
           {
            "exceed_by": 0,
            "required": 85,
            "status": "met",
            "trait": "data-analytics-skills",
            "user_value": 85
           },
           {
            "exceed_by": 0,
            "required": 75,
            "status": "met",
            "trait": "critical-thinking",
            "user_value": 75
           }
          ],
          "requirements_met": 2,
          "role_id": "consulting_tax-consulting",
          "role_type": "tax-consulting",
          "total_requirements": 2
         }
        ],
        "fmcg": [
         {
          "average_exceed": 5,
          "industry": "fmcg",
          "match_percentage": 100,
          "match_score": 100.5,
          "qualification_status": "qualified",
          "requirements_details": [
           {
            "exceed_by": 0,
            "required": 85,
            "status": "met",
            "trait": "numerical-reasoning-skills",
            "user_value": 85
           },
           {
            "exceed_by": 10,
            "required": 75,
            "status": "met",
            "trait": "data-analytics-skills",
            "user_value": 85
           }
          ],
          "requirements_met": 2,
          "role_id": "fmcg_finance",
          "role_type": "finance",
          "total_requirements": 2
         },
         {
          "average_exceed": 0,
          "industry": "fmcg",
          "match_percentage": 100,
          "match_score": 100,
          "qualification_status": "qualified",
          "requirements_details": [
           {
            "exceed_by": 0,
            "required": 85,
            "status": "met",
            "trait": "numerical-reasoning-skills",
            "user_value": 85
           },
           {
            "exceed_by": 0,
            "required": 75,
            "status": "met",
            "trait": "problem-solving",
            "user_value": 75
           }
          ],
          "requirements_met": 2,
          "role_id": "fmcg_operations-supply-chain",
          "role_type": "operations-supply-chain",
          "total_requirements": 2
         }
        ],
        "investment-banking": [
         {
          "average_exceed": 5,
          "industry": "investment-banking",
          "match_percentage": 100,
          "match_score": 100.5,
          "qualification_status": "qualified",
          "requirements_details": [
           {
            "exceed_by": 0,
            "required": 85,
            "status": "met",
            "trait": "numerical-reasoning-skills",
            "user_value": 85
           },
           {
            "exceed_by": 10,
            "required": 75,
            "status": "met",
            "trait": "data-analytics-skills",
            "user_value": 85
           }
          ],
          "requirements_met": 2,
          "role_id": "investment-banking_finance",
          "role_type": "finance",
          "total_requirements": 2
         }
        ]
       },
       "overall_top_3": [
        {
         "average_exceed": 5,
         "industry": "consulting",
         "match_percentage": 100,
         "match_score": 100.5,
         "qualification_status": "qualified",
         "requirements_details": [
          {
           "exceed_by": 0,
           "required": 85,
           "status": "met",
           "trait": "numerical-reasoning-skills",
           "user_value": 85
          },
          {
           "exceed_by": 10,
           "required": 75,
           "status": "met",
           "trait": "data-analytics-skills",
           "user_value": 85
          }
         ],
         "requirements_met": 2,
         "role_id": "consulting_finance-audit",
         "role_type": "finance-audit",
         "total_requirements": 2
        },
        {
         "average_exceed": 5,
         "industry": "investment-banking",
         "match_percentage": 100,
         "match_score": 100.5,
         "qualification_status": "qualified",
         "requirements_details": [
          {
           "exceed_by": 0,
           "required": 85,
           "status": "met",
           "trait": "numerical-reasoning-skills",
           "user_value": 85
          },
          {
           "exceed_by": 10,
           "required": 75,
           "status": "met",
           "trait": "data-analytics-skills",
           "user_value": 85
          }
         ],
         "requirements_met": 2,
         "role_id": "investment-banking_finance",
         "role_type": "finance",
         "total_requirements": 2
        },
        {
         "average_exceed": 5,
         "industry": "fmcg",
         "match_percentage": 100,
         "match_score": 100.5,
         "qualification_status": "qualified",
         "requirements_details": [
          {
           "exceed_by": 0,
           "required": 85,
           "status": "met",
           "trait": "numerical-reasoning-skills",
           "user_value": 85
          },
          {
           "exceed_by": 10,
           "required": 75,
           "status": "met",
           "trait": "data-analytics-skills",
           "user_value": 85
          }
         ],
         "requirements_met": 2,
         "role_id": "fmcg_finance",
         "role_type": "finance",
         "total_requirements": 2
        }
       ],
       "total_qualified": 5
      },
      "rarity": {
       "note": "Insufficient data",
       "rarity_score": 0.5
      },
      "raw_scores": {
       "3d-visual": 90,
       "aesthetic": 90,
       "attention-to-detail": 45,
       "comprehension-skills": 20,
       "critical-thinking": 75,
       "data-analytics-skills": 85,
       "depth-perception": 45,
       "logical-reasoning": 45,
       "numerical-reasoning-skills": 85,
       "persuasive-communication-skills": 45,
       "probability-estimations": 45,
       "problem-solving": 75,
       "quantitative-fluency": 65
      },
      "timestamp": "2025-12-21T14:19:55.865989",
      "user_id": "TEST-USER-1-v1",
      "versatility": {
       "industries_qualified": 3,
       "total_qualified_roles": 5,
       "versatility_score": 50
      }
     };
  }

}
